var React = require('react');

function Top (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M269.723,140.073h-.013l-1.606,7.283a209.023,209.023,0,0,1,163.677-.044l-1.6-7.252A215.094,215.094,0,0,0,269.723,140.073Z","transform":"translate(-268.104 -124.545)","key":1})]);
}

Top.defaultProps = {"width":"163.677","height":"22.811","viewBox":"0 0 163.677 22.811"};

module.exports = Top;

Top.default = Top;
